export default __webpack_public_path__ + "static/media/background-image.89b35344.jpg";